import { CompanyService } from "services";

function useDebtCollectionService() {
  const canAllowDebtCollection = (remiderCount: number | undefined) => {
    return remiderCount !== 0 && CompanyService.isDebtCollectionEnabled();
  };

  return { canAllowDebtCollection };
}

export default useDebtCollectionService;
